<template>
  <div>
    Não Encontrado
  </div>
</template>

<script>
export default {
  name: "NotFound"
}
</script>

<style scoped>

</style>